export default "__VITE_ASSET__79cb7cc3__"